import amazonId from '@amzn/amazon-id';
/**
 * Obfuscate id if it's currently deobfuscated (numerical)
 * @param id id to obfuscate
 * @returns obfuscated id or the original id if it does not exist
 */
export const getObfuscatedId = (id) => {
    let obfuscatedId = id;
    const idIsDeobfuscated = !isNaN(+id);
    if (id && idIsDeobfuscated) {
        obfuscatedId = amazonId.encryptCustomerId(id);
    }
    return obfuscatedId;
};
/**
 * Deobfuscate id if it's currently obfuscated (alphanumeric)
 * @param id id to deobfuscate
 * @returns deobfuscated id or the original id if it does not exist
 */
export const getDeobfuscatedId = (id) => {
    let deobfuscatedId = id;
    const idIsObfuscated = isNaN(+id);
    if (id && idIsObfuscated) {
        deobfuscatedId = amazonId.decryptCustomerId(id);
    }
    return deobfuscatedId;
};
/**
 * Check if given id is a valid obfuscated id.
 * @param id id to check.
 * @returns true if id is valid obfuscated id, otherwise false.
 */
export const isObfuscatedId = (id) => {
    // NodeJS-AmazonId-2.0 will return 0 for invalid id, but 3.0 will throw error.
    if (amazonId.decryptCustomerId(id) === 0) {
        return false;
    }
    return true;
};
/**
 * Check if given id is valid.
 * @param id id to check.
 * @returns true if id is a positive number or obfuscated, otherwise false.
 */
export const isValidId = (id) => {
    if (!id)
        return false;
    return (!isNaN(+id) && parseInt(id) > 0) || isObfuscatedId(id);
};
//# sourceMappingURL=ObfuscationUtils.js.map